import SummerYouLogo from "../assets/summeryou-alt-logo.png"

const SummerYouLoader = () => {
    return(
        <div className="fixed inset-0 flex items-center justify-center bg-black/10 z-50">
        <img src={SummerYouLogo} className="h-24 w-24 animate-bounce-slower rounded-full"/>
        </div>
    )
}

export default SummerYouLoader;